module.exports = __webpack_public_path__ + "static/logo-e4a38fbb5be0a3a9833461191ffa2d58.png";